import script from "./GiftPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftPreview.vue?vue&type=script&setup=true&lang=js"

import "./GiftPreview.vue?vue&type=style&index=0&id=4de3522e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de3522e"]])

export default __exports__